
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dkxqfiilbcuwlnxgtwkq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRreHFmaWlsYmN1d2xueGd0d2txIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDM0NzA3NDksImV4cCI6MjAxOTA0Njc0OX0.cCmBaB_MjXjERmqMBK9uSy6cWE0-8956uUejD6jWtvw';

// Standard Client für normale Datenbank-Operationen (mit RLS)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Service Role Client für Storage-Operationen und Datenbank-Inserts (umgeht RLS)
// WICHTIG: Service Role Key sollte als Umgebungsvariable gespeichert werden!
// Für jetzt: Bitte den Service Role Key aus deinem Supabase Dashboard hier eintragen
const supabaseServiceRoleKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY || '';

// Debug: Prüfe ob Service Role Key geladen wurde
if (!supabaseServiceRoleKey) {
  console.warn('⚠️ REACT_APP_SUPABASE_SERVICE_ROLE_KEY ist nicht gesetzt! Storage-Uploads werden möglicherweise fehlschlagen.');
} else {
  console.log('✅ Service Role Key geladen');
}

// Storage Client mit Service Role Key (umgeht RLS für Storage und Datenbank)
export const supabaseStorage = supabaseServiceRoleKey
  ? createClient(supabaseUrl, supabaseServiceRoleKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      }
    })
  : supabase; // Fallback auf normalen Client, wenn kein Service Role Key vorhanden
